import React, { Suspense } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ResponsiveUserManagementScreen = /*#__PURE__*/React.lazy(() => import("./TemporaryUserManagementScreen.js"));
export default function LazyUserManagementScreen({
  fallback,
  ...props
}) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: fallback || 'Loading...',
    children: /*#__PURE__*/_jsx(ResponsiveUserManagementScreen, {
      ...props
    })
  });
}